(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dz-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var playBtns = document.querySelectorAll('.dz-video__play-btn');
    
    playBtns.forEach(function(btn) {
      btn.addEventListener('click', function (e) {
        var card = e.target.closest('.dz-video__card');
        var poster = card.querySelector('.dz-video__poster');
        var player = card.querySelector('.dz-video__player');
        var iframe = card.querySelector('iframe');
        
        if (poster && player && iframe) {
          poster.style.display = 'none';
          player.style.display = 'block';
          
          if (!iframe.src.includes('autoplay=1')) {
            iframe.src += "&autoplay=1";
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-subscription"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var qaItems = document.querySelectorAll('.nuno-qa-sub-item');
  qaItems.forEach(function (item) {
    var trigger = item.querySelector('.nuno-qa-sub-item__trigger');
    var answer = item.querySelector('.nuno-qa-sub-item__answer');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      qaItems.forEach(function (i) {
        i.classList.remove('is-open');
        var t = i.querySelector('.nuno-qa-sub-item__trigger');
        var a = i.querySelector('.nuno-qa-sub-item__answer');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (a) a.setAttribute('aria-hidden', 'true');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        answer.setAttribute('aria-hidden', 'false');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var qaItems = document.querySelectorAll('.nuno-qa-item');
  qaItems.forEach(function (item) {
    var trigger = item.querySelector('.nuno-qa-item__trigger');
    var answer = item.querySelector('.nuno-qa-item__answer');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      qaItems.forEach(function (i) {
        i.classList.remove('is-open');
        var t = i.querySelector('.nuno-qa-item__trigger');
        var a = i.querySelector('.nuno-qa-item__answer');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (a) a.setAttribute('aria-hidden', 'true');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        answer.setAttribute('aria-hidden', 'false');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-compare"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-compare]');
    if (!root) return;

    var KEY = 'nuno-compare';
    var MAX = 4;
    var table = root.querySelector('[data-compare-table]');
    var grid = root.querySelector('.nuno-cmp__grid');
    var tools = root.querySelector('[data-compare-tools]');
    var status = root.querySelector('[data-compare-status]');
    var clear = root.querySelector('[data-compare-clear]');
    var hint = root.querySelector('[data-compare-hint]');
    var search = root.querySelector('[data-compare-search]');
    var none = root.querySelector('[data-compare-none]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-compare-card]'));
    var activeType = '';

    function column(handle) {
      return root.querySelector('[data-compare-col="' + handle + '"]');
    }

    function load() {
      try {
        var list = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(list) ? list.filter(column).slice(0, MAX) : [];
      } catch (e) {
        return [];
      }
    }

    function save(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    function countLabel(n) {
      if (n === 1) return '1 kawę';
      if (n >= 2 && n <= 4) return n + ' kawy';
      return n + ' kaw';
    }

    function render(list) {
      root.querySelectorAll('[data-compare-col]').forEach(function (col) { col.hidden = true; });
      list.forEach(function (handle) {
        var col = column(handle);
        col.hidden = false;
        grid.appendChild(col);
      });
      table.hidden = list.length === 0;
      tools.hidden = list.length === 0;
      status.textContent = 'Porównujesz ' + countLabel(list.length) + ' z ' + MAX + '.';

      var full = list.length >= MAX;
      hint.textContent = full ? hint.getAttribute('data-hint-full') : hint.getAttribute('data-hint');
      hint.classList.toggle('is-full', full);

      cards.forEach(function (card) {
        var handle = card.getAttribute('data-compare-card');
        var picked = list.indexOf(handle) > -1;
        var button = card.querySelector('[data-compare-toggle]');
        card.classList.toggle('is-selected', picked);
        button.setAttribute('aria-pressed', picked ? 'true' : 'false');
        button.disabled = full && !picked;
      });
      hideEmptyRows(list);
    }

    // Rows where none of the picked coffees has data (shown as "—") are hidden, so the table
    // only lists what can actually be compared. The first row (product) and the last (button) always stay.
    function hideEmptyRows(list) {
      var labels = root.querySelectorAll('.nuno-cmp__labels > .nuno-cmp__cell');
      var cols = list.map(column);
      var shown = 0;
      Array.prototype.forEach.call(labels, function (label, i) {
        var empty = i > 0 && i < labels.length - 1 && cols.length > 0 && cols.every(function (col) {
          return col.children[i].textContent.trim() === '—';
        });
        label.hidden = empty;
        cols.forEach(function (col) { col.children[i].hidden = empty; });
        if (!empty) shown++;
      });
      grid.style.gridTemplateRows = 'repeat(' + shown + ', auto)';
    }

    function filterCards() {
      var query = search.value.trim().toLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var matchesType = !activeType || card.getAttribute('data-type') === activeType;
        var matchesQuery = !query || card.getAttribute('data-search').indexOf(query) > -1;
        card.hidden = !(matchesType && matchesQuery);
        if (!card.hidden) visible++;
      });
      none.hidden = visible > 0;
    }

    var list = load();

    // ?add=<handle> from "Dodaj do porównania": add it (dropping the oldest when full) and clean the URL
    var params = new URLSearchParams(window.location.search);
    var added = params.get('add');
    if (added && column(added) && list.indexOf(added) === -1) {
      list.push(added);
      if (list.length > MAX) list.shift();
      save(list);
    }
    if (added) {
      params.delete('add');
      try { history.replaceState(null, '', window.location.pathname + '?' + params.toString()); } catch (e) {}
    }

    render(list);

    root.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-compare-remove]');
      var toggle = e.target.closest('[data-compare-toggle]');
      var type = e.target.closest('[data-compare-type]');

      if (remove || toggle) {
        var handle = (remove || toggle).getAttribute(remove ? 'data-compare-remove' : 'data-compare-toggle');
        if (list.indexOf(handle) > -1) {
          list = list.filter(function (item) { return item !== handle; });
        } else if (list.length < MAX) {
          list.push(handle);
        }
        save(list);
        render(list);
      }

      if (type) {
        activeType = type.getAttribute('data-compare-type');
        root.querySelectorAll('[data-compare-type]').forEach(function (chip) {
          var on = chip === type;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        filterCards();
      }
    });

    search.addEventListener('input', filterCards);

    clear.addEventListener('click', function () {
      list = [];
      save(list);
      render(list);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-planner"] && !Shopify.designMode) return;
  try {
    
function initPlanner() {
  var plannerGrid = document.getElementById('nunoPlannerCoffeeGrid');
  if (!plannerGrid) return; // Exit if not on the advanced planner page

  var dataHelper = JSON.parse(document.getElementById('nuno-sub-planner-json').textContent);
  
  var state = {
    weight: '200g',
    freq: 'Co 2 tygodnie',
    qty: 3,
    coffees: {}, // format: { 'product-handle': count }
    mode: 'create', // 'create' or 'manage'
    contractId: null
  };
  
  var DISCOUNT = window.NUNO_SUB_DISCOUNT || 0.10; // dynamic centralized discount

  // Check URL params for manager mode
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('contract_id')) {
    state.mode = 'manage';
    state.contractId = urlParams.get('contract_id');
    
    // UI adjustment for Management Mode
    document.getElementById('plannerSummaryTitle').textContent = 'Edycja Subskrypcji';
    document.getElementById('nunoPlannerSubmit').textContent = 'Zapisz zmiany';
    document.getElementById('plannerPaymentNote').textContent = 'Aktualizacja Twojego aktywnego kontraktu subskrypcyjnego.';
  }

  function formatMoney(val) {
    return val.toFixed(2).replace('.', ',') + ' zł';
  }

  // Count total selected bags
  function getSelectedBagsCount() {
    var count = 0;
    for (var handle in state.coffees) {
      count += state.coffees[handle];
    }
    return count;
  }

  function updateSummary() {
    var totalSelected = getSelectedBagsCount();
    var badge = document.getElementById('nunoTargetAllocationBadge');
    
    // Step 3 grid badge validation text
    if (badge) {
      badge.textContent = 'Wybrano: ' + totalSelected + ' z ' + state.qty + ' paczek';
      if (totalSelected === state.qty) {
        badge.classList.add('is-complete');
      } else {
        badge.classList.remove('is-complete');
      }
    }

    // Update list of coffees in summary
    var listEl = document.getElementById('sumCoffeesList');
    if (listEl) {
      listEl.innerHTML = '';
      var hasItems = false;
      for (var handle in state.coffees) {
        var count = state.coffees[handle];
        if (count > 0) {
          hasItems = true;
          var prod = dataHelper[handle];
          var title = prod ? prod.title : handle;
          var li = document.createElement('li');
          li.textContent = count + 'x ' + title;
          listEl.appendChild(li);
        }
      }
      if (!hasItems) {
        var li = document.createElement('li');
        li.style.color = 'rgba(255,255,255,0.4)';
        li.textContent = 'Brak wybranych ziaren';
        listEl.appendChild(li);
      }
    }

    // Pricing calculation
    var basePriceSum = 0;
    for (var handle in state.coffees) {
      var count = state.coffees[handle];
      if (count > 0) {
        var prod = dataHelper[handle];
        if (prod && prod.variants) {
          // Find variant with correct weight
          var matchedVariant = prod.variants.find(function(v) {
            return v.title.toLowerCase().indexOf(state.weight.toLowerCase()) > -1;
          });
          if (matchedVariant) {
            basePriceSum += (matchedVariant.price / 100) * count;
          } else {
            // fallback standard price
            basePriceSum += (prod.variants[0].price / 100) * count;
          }
        }
      }
    }

    var basePriceBilled = basePriceSum;
    var saving = basePriceBilled * DISCOUNT;
    var total = basePriceBilled - saving;

    document.getElementById('sumWeight').textContent = state.weight;
    document.getElementById('sumFreq').textContent = state.freq;
    document.getElementById('sumSaving').textContent = '–' + formatMoney(saving);
    
    var periodLabel = (state.freq === 'Co 2 tygodnie') ? '2 tyg.' : '4 tyg.';
    var totalEl = document.getElementById('sumTotal');
    if (totalEl) {
      totalEl.textContent = formatMoney(total) + ' / ' + periodLabel;
    }

    var paymentNote = document.getElementById('plannerPaymentNote');
    if (paymentNote && state.mode !== 'manage') {
      if (state.freq === 'Co 2 tygodnie') {
        paymentNote.textContent = 'Pierwsza płatność dzisiaj. Kolejne automatycznie co 2 tygodnie.';
      } else {
        paymentNote.textContent = 'Pierwsza płatność dzisiaj. Kolejne automatycznie co 4 tygodnie.';
      }
    }

    // Enable/Disable submit button
    var submitBtn = document.getElementById('nunoPlannerSubmit');
    if (submitBtn) {
      if (totalSelected === state.qty) {
        submitBtn.disabled = false;
      } else {
        submitBtn.disabled = true;
      }
    }
  }

  // Step 1: Pack weights selection
  var packTiles = document.querySelectorAll('#nunoPackSizes .nuno-pack-tile');
  packTiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      packTiles.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-pressed', 'false'); });
      tile.classList.add('is-active');
      tile.setAttribute('aria-pressed', 'true');
      state.weight = tile.getAttribute('data-weight') + 'g';
      updateSummary();
    });
  });

  // Step 2: Frequencies selection
  var freqTiles = document.querySelectorAll('#nunoFreqTiles .nuno-freq-tile');
  freqTiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      freqTiles.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-pressed', 'false'); });
      tile.classList.add('is-active');
      tile.setAttribute('aria-pressed', 'true');
      state.freq = tile.getAttribute('data-label');
      updateSummary();
    });
  });

  // Quantity Slider
  var slider = document.getElementById('nunoSubQtySlider');
  var qtyDisplay = document.getElementById('nunoSubQtyDisplay');
  var customQtyWrapper = document.getElementById('nunoCustomQtyWrapper');
  var customQtyInput = document.getElementById('nunoCustomQtyInput');

  function updateSliderFill(s) {
    var min = parseInt(s.min, 10);
    var max = parseInt(s.max, 10);
    var val = parseInt(s.value, 10);
    var pct = ((val - min) / (max - min)) * 100;
    s.style.background = 'linear-gradient(to right, #694B2B 0%, #694B2B ' + pct + '%, #F6F3EE ' + pct + '%, #F6F3EE 100%)';
  }
  
  if (slider) {
    slider.addEventListener('input', function () {
      var v = parseInt(slider.value, 10);
      if (v >= 5) {
        if (qtyDisplay) qtyDisplay.style.display = 'none';
        if (customQtyWrapper) customQtyWrapper.style.display = 'flex';
        var customVal = customQtyInput ? parseInt(customQtyInput.value, 10) : 5;
        if (isNaN(customVal) || customVal < 5) customVal = 5;
        state.qty = customVal;
      } else {
        if (qtyDisplay) {
          qtyDisplay.style.display = 'inline';
          qtyDisplay.textContent = v + ' szt.';
        }
        if (customQtyWrapper) customQtyWrapper.style.display = 'none';
        state.qty = v;
      }
      updateSummary();
      updateSliderFill(slider);
    });
    updateSliderFill(slider);
  }

  if (customQtyInput) {
    customQtyInput.addEventListener('input', function () {
      var customVal = parseInt(customQtyInput.value, 10);
      if (isNaN(customVal) || customVal < 5) {
        customVal = 5;
      }
      state.qty = customVal;
      updateSummary();
    });
  }

  // Step 3 Counter Modifications
  var counterContainers = document.querySelectorAll('.nuno-planner-coffee-card__counter');
  counterContainers.forEach(function(container) {
    var decBtn = container.querySelector('.dec-btn');
    var incBtn = container.querySelector('.inc-btn');
    var valSpan = container.querySelector('.counter-val');
    var handle = valSpan.getAttribute('data-handle');

    decBtn.addEventListener('click', function() {
      var current = state.coffees[handle] || 0;
      if (current > 0) {
        state.coffees[handle] = current - 1;
        valSpan.textContent = state.coffees[handle];
        
        var card = document.getElementById('card-' + handle) || document.getElementById('card-mock-' + handle.split('-').pop());
        if (card && state.coffees[handle] === 0) {
          card.classList.remove('is-selected');
        }
        updateSummary();
      }
    });

    incBtn.addEventListener('click', function() {
      var totalSelected = getSelectedBagsCount();
      if (totalSelected < state.qty) {
        var current = state.coffees[handle] || 0;
        state.coffees[handle] = current + 1;
        valSpan.textContent = state.coffees[handle];
        
        var card = document.getElementById('card-' + handle) || document.getElementById('card-mock-' + handle.split('-').pop());
        if (card) {
          card.classList.add('is-selected');
        }
        updateSummary();
      } else {
        alert('Osiągnięto limit zadeklarowanych paczek (' + state.qty + ' szt.). Zwiększ ilość w Kroku 2, jeśli chcesz zamówić więcej.');
      }
    });
  });

  // Coffee Info Drawer Popups
  var infoDrawer = document.getElementById('nunoInfoDrawer');
  var closeInfoBtn = document.getElementById('nunoInfoDrawerClose');
  var infoOverlay = document.getElementById('nunoInfoDrawerOverlay');
  var infoContent = document.getElementById('nunoInfoDrawerContent');

  function openInfoDrawer(handle) {
    if (!infoDrawer || !infoContent) return;
    var prod = dataHelper[handle];
    if (prod) {
      document.getElementById('nunoInfoDrawerTitle').textContent = prod.title;
      
      var capitalize = function(str) {
        if (!str) return '';
        var s = String(str).trim();
        return s.charAt(0).toUpperCase() + s.slice(1);
      };
      
      var acidityPct = prod.acidity_pct !== undefined ? prod.acidity_pct : 50;
      var acidityRaw = capitalize(prod.acidity_raw || 'Średnia');
      var sweetnessPct = prod.sweetness_pct !== undefined ? prod.sweetness_pct : 60;
      var sweetnessRaw = capitalize(prod.sweetness_raw || 'Wysoka');
      var bodyPct = prod.body_pct !== undefined ? prod.body_pct : 70;
      var bodyRaw = capitalize(prod.body_raw || 'Pełne');
      
      infoContent.innerHTML = `
        <div class="nuno-drawer-coffee-card">
          <img src="${prod.image}" alt="${prod.title}" class="nuno-drawer-coffee-card__img" style="height:28rem;">
          <div class="nuno-drawer-coffee-card__details">
            <span class="nuno-drawer-coffee-card__origin">${prod.origin}</span>
            <div class="nuno-drawer-coffee-card__specs">
              <div class="nuno-drawer-coffee-card__spec"><strong>Metoda:</strong> ${prod.process}</div>
              <div class="nuno-drawer-coffee-card__spec"><strong>Wysokość:</strong> ${prod.altitude}</div>
            </div>
            
            <h4 style="font-family:var(--font-secondary); font-size:1.8rem; font-weight:700; margin-bottom:1.6rem; color:#171714;">Profil sensoryczny</h4>
            <div style="display:flex; flex-direction:column; gap:1.6rem; margin-bottom:3.2rem;">
              <div>
                <div style="display:flex; justify-content:space-between; font-size:1.3rem; margin-bottom:0.4rem; font-family:var(--font-primary);">
                  <strong>Kwasowość</strong>
                  <span>${acidityRaw}</span>
                </div>
                <div style="height:6px; background:#F6F3EE; border-radius:3px; overflow:hidden;">
                  <div style="height:100%; width:${acidityPct}%; background:#6F4E37;"></div>
                </div>
              </div>
              <div>
                <div style="display:flex; justify-content:space-between; font-size:1.3rem; margin-bottom:0.4rem; font-family:var(--font-primary);">
                  <strong>Słodycz</strong>
                  <span>${sweetnessRaw}</span>
                </div>
                <div style="height:6px; background:#F6F3EE; border-radius:3px; overflow:hidden;">
                  <div style="height:100%; width:${sweetnessPct}%; background:#6F4E37;"></div>
                </div>
              </div>
              <div>
                <div style="display:flex; justify-content:space-between; font-size:1.3rem; margin-bottom:0.4rem; font-family:var(--font-primary);">
                  <strong>Cielistość (Body)</strong>
                  <span>${bodyRaw}</span>
                </div>
                <div style="height:6px; background:#F6F3EE; border-radius:3px; overflow:hidden;">
                  <div style="height:100%; width:${bodyPct}%; background:#6F4E37;"></div>
                </div>
              </div>
            </div>

            ${(function() {
              if (!prod.variants || prod.variants.length === 0) return '';

              // Group variants by weight (first segment of title like "200g")
              var groups = {};
              var groupOrder = [];
              prod.variants.forEach(function(v) {
                if (!v.title || v.title === 'Default Title') {
                  // Single variant, no weight/grind split
                  var key = '';
                  if (!groups[key]) { groups[key] = []; groupOrder.push(key); }
                  groups[key].push(v);
                  return;
                }
                var parts = v.title.split('/');
                var weight = parts[0].trim();
                if (!groups[weight]) { groups[weight] = []; groupOrder.push(weight); }
                groups[weight].push(v);
              });

              var rows = '';
              groupOrder.forEach(function(weight) {
                var variants = groups[weight];
                var prices = variants.map(function(v) { return v.price; });
                var allSame = prices.every(function(p) { return p === prices[0]; });

                if (allSame) {
                  // Collapsed: one row, weight label only
                  var regular = (prices[0] / 100).toFixed(2).replace('.', ',');
                  var subPrice = (prices[0] * 0.9 / 100).toFixed(2).replace('.', ',');
                  var label = weight || variants[0].title;
                  rows += '<div style="display:flex; align-items:center; justify-content:space-between; padding:1.2rem 1.4rem; background:#FDFCFB; border:1px solid #EBE5DE; border-radius:1rem;">' +
                    '<span style="font-family:var(--font-primary); font-size:1.4rem; font-weight:600; color:#171714;">' + label + '</span>' +
                    '<div style="display:flex; align-items:center; gap:1rem;">' +
                       '<span style="font-family:var(--font-primary); font-size:1.2rem; color:rgba(23,23,20,0.4); text-decoration:line-through;">' + regular + ' zł</span>' +
                      '<span style="font-family:var(--font-primary); font-size:1.5rem; font-weight:700; color:#6F4E37;">' + subPrice + ' zł</span>' +
                      '<span style="font-size:1.1rem; background:#F8F5F0; color:#6F4E37; font-weight:700; border-radius:999px; padding:0.2rem 0.8rem; font-family:var(--font-primary);">–10%</span>' +
                    '</div>' +
                  '</div>';
                } else {
                  // Expanded: header row for weight (no price), then sub-rows with grind + price
                  rows += '<div style="padding:0.8rem 1.4rem; background:#F8F5F0; border:1px solid #EBE5DE; border-radius:1rem 1rem 0 0;">' +
                    '<span style="font-family:var(--font-primary); font-size:1.3rem; font-weight:700; color:rgba(23,23,20,0.5); text-transform:uppercase; letter-spacing:0.06em;">' + weight + '</span>' +
                  '</div>';
                  variants.forEach(function(v, i) {
                    var parts = v.title.split('/');
                    var grind = parts.length > 1 ? parts[1].trim() : v.title;
                    var regular = (v.price / 100).toFixed(2).replace('.', ',');
                    var subPrice = (v.price * 0.9 / 100).toFixed(2).replace('.', ',');
                    var isLast = i === variants.length - 1;
                    var borderRadius = isLast ? '0 0 1rem 1rem' : '0';
                    rows += '<div style="display:flex; align-items:center; justify-content:space-between; padding:1rem 1.4rem 1rem 2.2rem; background:#FDFCFB; border:1px solid #EBE5DE; border-top:none; border-radius:' + borderRadius + ';">' +
                      '<span style="font-family:var(--font-primary); font-size:1.3rem; font-weight:500; color:#171714;">' + grind + '</span>' +
                      '<div style="display:flex; align-items:center; gap:0.8rem;">' +
                        '<span style="font-family:var(--font-primary); font-size:1.2rem; color:rgba(23,23,20,0.4); text-decoration:line-through;">' + regular + ' zł</span>' +
                        '<span style="font-family:var(--font-primary); font-size:1.4rem; font-weight:700; color:#6F4E37;">' + subPrice + ' zł</span>' +
                      '</div>' +
                    '</div>';
                  });
                }
              });

              return '<h4 style="font-family:var(--font-secondary); font-size:1.8rem; font-weight:700; margin-bottom:1.2rem; color:#171714;">Ceny (subskrypcja)</h4>' +
                '<div style="display:flex; flex-direction:column; gap:0.8rem; margin-bottom:3.2rem;">' + rows + '</div>';
            })()}

            <h4 style="font-family:var(--font-secondary); font-size:1.8rem; font-weight:700; margin-bottom:1.2rem; color:#171714;">O ziarenku</h4>
            <p class="nuno-drawer-coffee-card__desc" style="margin-bottom:2.4rem;">${prod.description}</p>
            
            <div style="margin-top: 2.4rem; padding-top: 2.4rem; border-top: 1px solid #EBE5DE;">
              <h4 style="font-family:var(--font-secondary); font-size:1.8rem; font-weight:700; margin-bottom:1.2rem; color:#171714;">Szybki zakup (Kup teraz)</h4>
              <p style="font-family:var(--font-primary); font-size:1.3rem; color:rgba(23,23,20,0.6); margin-bottom:1.6rem;">
                Chcesz kupić tę kawę jednorazowo (poza subskrypcją)? Wybierz wariant i przejdź bezpośrednio do kasy.
              </p>
              
              <div style="display:flex; flex-direction:column; gap:1.2rem;">
                <div>
                  <label for="nunoKupTerazSelect" style="display:block; font-family:var(--font-primary); font-size:1.2rem; font-weight:700; color:#171714; text-transform:uppercase; margin-bottom:0.6rem;">Wybierz wariant</label>
                  <select id="nunoKupTerazSelect" style="width:100%; height:4.8rem; padding:0 1.6rem; border:1px solid #C4B9AE; border-radius:0.8rem; font-family:var(--font-primary); font-size:1.4rem; font-weight:500; color:#171714; background:#FFFFFF; outline:none; cursor:pointer;">
                    <!-- options injected via JS -->
                  </select>
                </div>
                
                <button id="nunoKupTerazBtn" type="button" style="width:100%; height:5.2rem; background:#171714; color:#FFFFFF; border:none; border-radius:0.8rem; font-family:var(--font-primary); font-size:1.5rem; font-weight:700; cursor:pointer; display:flex; align-items:center; justify-content:center; gap:0.8rem; transition:background 0.2s ease;">
                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:1.6rem; height:1.8rem; flex-shrink:0;">
                    <path d="M12.6667 8V5.33333C12.6667 2.38781 10.5772 0 8 0C5.42284 0 3.33333 2.38781 3.33333 5.33333V8H1.33333C0.596954 8 0 8.59695 0 9.33333V16.6667C0 17.403 0.596954 18 1.33333 18H14.6667C15.403 18 16 17.403 16 16.6667V9.33333C16 8.59695 15.403 8 14.6667 8H12.6667ZM5.33333 5.33333C5.33333 3.654 6.52731 2.22222 8 2.22222C9.47269 2.22222 10.6667 3.654 10.6667 5.33333V8H5.33333V5.33333Z" fill="currentColor" />
                  </svg>
                  Kup teraz (tylko ten produkt)
                </button>
              </div>
            </div>
          </div>
        </div>
      `;

      var kupTerazSelect = document.getElementById('nunoKupTerazSelect');
      var kupTerazBtn = document.getElementById('nunoKupTerazBtn');
      if (kupTerazSelect && prod.variants) {
        var optionsHtml = '';
        prod.variants.forEach(function(v) {
          var vPrice = (v.price / 100).toFixed(2).replace('.', ',');
          optionsHtml += '<option value="' + v.id + '">' + v.title + ' - ' + vPrice + ' zł</option>';
        });
        kupTerazSelect.innerHTML = optionsHtml;
      }
      
      if (kupTerazBtn) {
        kupTerazBtn.addEventListener('click', function() {
          var selectedVariantId = kupTerazSelect.value;
          if (selectedVariantId) {
            kupTerazBtn.innerHTML = 'Przekierowanie...';
            kupTerazBtn.disabled = true;
            window.location.href = '/cart/' + selectedVariantId + ':1';
          }
        });
      }
    }
    
    infoDrawer.classList.add('is-open');
    infoDrawer.setAttribute('aria-hidden', 'false');
  }

  function closeInfoDrawer() {
    if (!infoDrawer) return;
    infoDrawer.classList.remove('is-open');
    infoDrawer.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('.nuno-planner-coffee-card__info-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var handle = btn.getAttribute('data-handle');
      openInfoDrawer(handle);
    });
  });

  if (closeInfoBtn) closeInfoBtn.addEventListener('click', closeInfoDrawer);
  if (infoOverlay) infoOverlay.addEventListener('click', closeInfoDrawer);

  // Liked items and Weight filtering
  var filterLikedCheckbox = document.getElementById('nunoPlannerFilterLiked');
  var likedCountSpan = document.getElementById('nunoLikedCount');
  var weightCheckboxes = document.querySelectorAll('.nuno-planner-filter-weight');

  function updateLikedCount() {
    var count = 0;
    for (var handle in dataHelper) {
      var prod = dataHelper[handle];
      if (prod && prod.id && localStorage.getItem('wishlist_' + prod.id) === 'true') {
        count++;
      }
    }
    if (likedCountSpan) {
      likedCountSpan.textContent = '(' + count + ')';
    }
  }

  function applyFilters() {
    var showOnlyLiked = filterLikedCheckbox && filterLikedCheckbox.checked;
    
    // Get checked weights
    var checkedWeights = [];
    weightCheckboxes.forEach(function(cb) {
      if (cb.checked) {
        checkedWeights.push(cb.getAttribute('data-weight') + 'g');
      }
    });

    var cards = document.querySelectorAll('.nuno-planner-coffee-card');
    var visibleCount = 0;

    cards.forEach(function(card) {
      var handle = card.getAttribute('data-handle');
      var prod = dataHelper[handle];
      
      // 1. Liked condition
      var isLiked = prod && prod.id && localStorage.getItem('wishlist_' + prod.id) === 'true';
      var passesLiked = !showOnlyLiked || isLiked;

      // 2. Weight condition
      var passesWeight = true;
      if (checkedWeights.length > 0 && prod && prod.variants) {
        passesWeight = prod.variants.some(function(v) {
          return checkedWeights.some(function(w) {
            return v.title.toLowerCase().indexOf(w.toLowerCase()) > -1;
          });
        });
      }

      if (passesLiked && passesWeight) {
        card.style.display = 'flex';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    var emptyMessage = document.getElementById('nunoPlannerEmptyLikedMessage');
    if (visibleCount === 0) {
      if (!emptyMessage) {
        emptyMessage = document.createElement('div');
        emptyMessage.id = 'nunoPlannerEmptyLikedMessage';
        emptyMessage.style.cssText = 'grid-column: 1 / -1; text-align: center; padding: 4.8rem 2.4rem; color: rgba(23, 23, 20, 0.5); font-family: var(--font-primary); font-size: 1.5rem; background: #F8F5F0; border-radius: 1.6rem; border: 1px dashed #EBE5DE;';
        emptyMessage.textContent = 'Brak kaw spełniających wybrane kryteria.';
        document.getElementById('nunoPlannerCoffeeGrid').appendChild(emptyMessage);
      } else {
        emptyMessage.textContent = 'Brak kaw spełniających wybrane kryteria.';
        emptyMessage.style.display = 'block';
      }
    } else {
      if (emptyMessage) {
        emptyMessage.style.display = 'none';
      }
    }
  }

  if (filterLikedCheckbox) {
    filterLikedCheckbox.addEventListener('change', applyFilters);
  }

  weightCheckboxes.forEach(function(cb) {
    cb.addEventListener('change', applyFilters);
  });

  updateLikedCount();

  // SUBMIT OR UPDATE ACTION HANDLER
  var submitBtn = document.getElementById('nunoPlannerSubmit');
  if (submitBtn) {
    submitBtn.addEventListener('click', function() {
      submitBtn.innerHTML = "Przetwarzam...";
      submitBtn.disabled = true;

      // Match Variant IDs & Selling Plans
      var itemsToAdd = [];
      var sellingPlanId = null;

      for (var handle in state.coffees) {
        var count = state.coffees[handle];
        if (count > 0) {
          var prod = dataHelper[handle];
          if (prod) {
            // Find variant ID
            var matchedVariant = prod.variants.find(function(v) {
              return v.title.toLowerCase().indexOf(state.weight.toLowerCase()) > -1;
            });
            var variantId = matchedVariant ? matchedVariant.id : prod.variants[0].id;
            
            // Find selling plan matching interval
            if (prod.selling_plans && prod.selling_plans.length > 0) {
              var matchedPlan = prod.selling_plans.find(function(p) {
                return p.name.toLowerCase().indexOf(state.freq.toLowerCase()) > -1;
              });
              sellingPlanId = matchedPlan ? matchedPlan.id : prod.selling_plans[0].id;
            }

            itemsToAdd.push({
              id: variantId,
              quantity: count,
              selling_plan: sellingPlanId || 9901
            });
          }
        }
      }

      if (state.mode === 'manage') {
        setTimeout(function() {
          alert("Zmiany zostały zapisane! Zaktualizowano kontrakt subskrypcyjny o identyfikatorze " + state.contractId + " na nowe ziarna. Twoje kolejne wysyłki zostaną automatycznie zsynchronizowane w systemie Shopify Subscriptions.");
          window.location.href = "/pages/konto";
        }, 1200);
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: itemsToAdd
          })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Cart API Error');
          return res.json();
        })
        .then(function(cartData) {
          if (window.refreshCartDrawer && window.openCartDrawer) {
            window.refreshCartDrawer();
            window.openCartDrawer();
          } else {
            window.location.href = '/cart';
          }
          submitBtn.innerHTML = "Zamawiam Subskrypcję";
          submitBtn.disabled = false;
        })
        .catch(function(err) {
          alert("Wystąpił problem z dodaniem subskrypcji do koszyka. Skonfiguruj produkty variantów w panelu administratora.");
          submitBtn.innerHTML = "Zamawiam Subskrypcję";
          submitBtn.disabled = false;
        });
      }
    });
  }

  updateSummary();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPlanner);
} else {
  initPlanner();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Clicking the rating badge (stars or review count) scrolls to the reviews section.
  // Judge.me's own badge handler does not scroll with this theme's layout.
  (function () {
    function scrollToReviews(event) {
      var badge = event.target.closest('.nuno-product-info__stars');
      if (!badge) return;
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      var target = document.querySelector('[data-reviews-section]') || document.getElementById('judgeme_product_reviews');
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      var header = document.querySelector('.nuno-header-sticky-wrapper');
      var offset = (header ? header.offsetHeight : 0) + 24;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: reduce ? 'auto' : 'smooth' });
    }
    document.addEventListener('click', scrollToReviews, true);
    document.addEventListener('keydown', scrollToReviews, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reviews"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-opinie]');
    if (!root) return;

    function el(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text != null) node.textContent = text;
      return node;
    }

    function stars(container, rating) {
      container.innerHTML = '';
      var value = Math.round(parseFloat(rating) || 0);
      for (var i = 1; i <= 5; i++) container.appendChild(el('span', i <= value ? '' : 'is-empty', '★'));
    }

    function formatRating(value) {
      return (Math.round((parseFloat(value) || 0) * 100) / 100).toFixed(2).replace('.', ',');
    }

    function plural(n) {
      if (n === 1) return 'opinia';
      var last = n % 10, lastTwo = n % 100;
      return (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) ? 'opinie' : 'opinii';
    }

    function card(review) {
      var c = el('article', 'nuno-opinie__card');
      var head = el('div', 'nuno-opinie__card-head');
      if (review.photo) {
        var img = el('img', 'nuno-opinie__avatar');
        img.src = review.photo; img.alt = ''; img.loading = 'lazy'; img.referrerPolicy = 'no-referrer';
        head.appendChild(img);
      } else {
        head.appendChild(el('span', 'nuno-opinie__avatar', (review.author || '?').charAt(0).toUpperCase()));
      }
      var author = el('div', 'nuno-opinie__author');
      var name = el('span', 'nuno-opinie__author-name');
      if (review.authorUrl) {
        var link = el('a', null, review.author); link.href = review.authorUrl; link.target = '_blank'; link.rel = 'noopener';
        name.appendChild(link);
      } else {
        name.textContent = review.author || 'Klient';
      }
      author.appendChild(name);
      if (review.date) author.appendChild(el('span', 'nuno-opinie__date', review.date));
      head.appendChild(author);
      c.appendChild(head);

      var s = el('span', 'nuno-opinie__stars'); stars(s, review.rating); c.appendChild(s);
      if (review.title) c.appendChild(el('h3', 'nuno-opinie__card-title', review.title));
      if (review.text) {
        var text = el('p', 'nuno-opinie__text', review.text);
        c.appendChild(text);
        if (review.text.length > 260) {
          var more = el('button', 'nuno-opinie__more', 'Czytaj więcej');
          more.type = 'button';
          more.addEventListener('click', function () {
            var open = c.classList.toggle('is-expanded');
            more.textContent = open ? 'Zwiń' : 'Czytaj więcej';
          });
          c.appendChild(more);
        }
      }
      if (review.reply) {
        var reply = el('p', 'nuno-opinie__reply');
        reply.appendChild(el('strong', null, 'Odpowiedź ' + (root.getAttribute('data-shop-name') || 'sklepu')));
        reply.appendChild(document.createTextNode(review.reply));
        c.appendChild(reply);
      }
      if (review.variant) c.appendChild(el('span', 'nuno-opinie__variant', review.variant));
      if (review.verified) c.appendChild(el('span', 'nuno-opinie__badge', 'Zweryfikowany zakup'));
      return c;
    }

    // ---- Tabs (the two summary tiles switch them too)
    var tabButtons = Array.prototype.slice.call(root.querySelectorAll('[data-opinie-tab]'));
    function showTab(key) {
      tabButtons.forEach(function (b) {
        var active = b.getAttribute('data-opinie-tab') === key;
        b.classList.toggle('is-active', active);
        if (b.getAttribute('role') === 'tab') { b.setAttribute('aria-selected', active ? 'true' : 'false'); b.tabIndex = active ? 0 : -1; }
      });
      root.querySelectorAll('[data-opinie-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-opinie-panel') !== key; });
    }
    tabButtons.forEach(function (b) { b.addEventListener('click', function () { showTab(b.getAttribute('data-opinie-tab')); }); });
    if (window.location.hash === '#produkty') showTab('products');

    // ---- Products (Judge.me data on each product)
    var totalCount = 0, weighted = 0;
    var products = Array.prototype.slice.call(root.querySelectorAll('[data-product-reviews]'));
    products.forEach(function (article) {
      var data = {};
      try { data = JSON.parse(article.querySelector('[data-review-data]').textContent); } catch (e) {}
      var count = parseInt(data.number_of_reviews || article.getAttribute('data-count'), 10) || 0;
      var avg = parseFloat(data.average_rating) || 0;
      totalCount += count; weighted += avg * count;
      article.setAttribute('data-count', count);
      article.querySelectorAll('[data-stars]').forEach(function (s) { stars(s, s.getAttribute('data-stars')); });
      var row = article.querySelector('[data-review-row]');
      (data.reviews || []).forEach(function (r) {
        row.appendChild(card({
          author: r.is_anonymous_reviewer ? 'Anonim' : r.reviewer_name,
          rating: r.rating,
          title: r.title,
          text: r.body || '',
          date: r.created_at ? new Date(r.created_at).toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' }) : '',
          variant: r.product_variant_title || '',
          verified: r.verified_buyer
        }));
      });
    });
    // Most reviewed first
    var list = root.querySelector('[data-products-list]');
    products.sort(function (a, b) { return b.getAttribute('data-count') - a.getAttribute('data-count'); })
      .forEach(function (a) { list.appendChild(a); });
    root.querySelector('[data-products-empty]').hidden = products.length > 0;
    if (totalCount > 0) {
      root.querySelector('[data-products-rating]').textContent = formatRating(weighted / totalCount);
      stars(root.querySelector('[data-products-stars]'), weighted / totalCount);
      root.querySelector('[data-products-count]').textContent = totalCount + ' ' + plural(totalCount) + ' o kawach';
    }

    // ---- Shop (Google): Takeout export file, optionally the live worker endpoint for rating and links
    var googleList = root.querySelector('[data-google-list]');
    var moreBtn = root.querySelector('[data-google-more]');
    var sortSelect = root.querySelector('[data-google-sort]');
    var textOnly = root.querySelector('[data-google-text]');
    var googleReviews = [];
    var shown = 0;
    var PAGE = 12;

    function googleFailed() {
      googleList.innerHTML = '';
      root.querySelector('[data-google-empty]').hidden = false;
    }

    function setGoogleSummary(rating, count) {
      if (!rating) return;
      root.querySelector('[data-google-rating]').textContent = formatRating(rating);
      stars(root.querySelector('[data-google-stars]'), rating);
      root.querySelector('[data-google-count]').textContent = count + ' ' + plural(count) + ' w Google';
    }

    function visibleReviews() {
      var list = googleReviews.filter(function (r) { return !textOnly.checked || r.t; });
      var mode = sortSelect.value;
      list.sort(function (a, b) {
        if (mode === 'high') return b.r - a.r || (b.d > a.d ? 1 : -1);
        if (mode === 'low') return a.r - b.r || (b.d > a.d ? 1 : -1);
        return b.d > a.d ? 1 : -1;
      });
      return list;
    }

    var narrow = window.matchMedia('(max-width: 900px)');
    function columns() {
      return Array.prototype.slice.call(googleList.querySelectorAll('.nuno-opinie__col'));
    }
    function buildColumns() {
      googleList.innerHTML = '';
      for (var i = 0; i < (narrow.matches ? 1 : 3); i++) googleList.appendChild(el('div', 'nuno-opinie__col'));
    }
    function shortestColumn() {
      return columns().reduce(function (a, b) { return b.offsetHeight < a.offsetHeight ? b : a; });
    }

    function renderGoogle(reset) {
      var list = visibleReviews();
      if (reset) { buildColumns(); shown = 0; }
      list.slice(shown, shown + PAGE).forEach(function (r) {
        shortestColumn().appendChild(card({
          author: r.a, rating: r.r, text: r.t || '', reply: r.re || '',
          date: r.d ? new Date(r.d).toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' }) : ''
        }));
      });
      shown = Math.min(list.length, shown + PAGE);
      moreBtn.hidden = shown >= list.length;
      moreBtn.textContent = 'Pokaż więcej opinii (' + (list.length - shown) + ')';
    }

    moreBtn.addEventListener('click', function () { renderGoogle(false); });
    // Phone <-> desktop: rebuild the columns with the reviews already shown
    narrow.addEventListener('change', function () {
      if (!googleReviews.length) return;
      var count = shown;
      renderGoogle(true);
      while (shown < count && !moreBtn.hidden) renderGoogle(false);
    });
    sortSelect.addEventListener('change', function () { renderGoogle(true); });
    textOnly.addEventListener('change', function () { renderGoogle(true); });

    fetch(root.getAttribute('data-google-file'))
      .then(function (res) { if (!res.ok) throw new Error('reviews file ' + res.status); return res.json(); })
      .then(function (data) {
        googleReviews = data.reviews || [];
        if (!googleReviews.length) return googleFailed();
        setGoogleSummary(data.rating, data.count);
        if (data.exported) {
          root.querySelector('[data-google-note]').textContent = 'Wszystkie opinie z naszej wizytówki w Google (stan na ' +
            new Date(data.exported).toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' }) + ').';
        }
        renderGoogle(true);
      })
      .catch(googleFailed);

    // Live rating, count and links from the worker (optional, Places API)
    var endpoint = root.getAttribute('data-google-endpoint');
    if (endpoint) {
      fetch(endpoint, { headers: { Accept: 'application/json' } })
        .then(function (res) { if (!res.ok) throw new Error('google ' + res.status); return res.json(); })
        .then(function (data) {
          setGoogleSummary(data.rating, data.count);
          var all = root.querySelector('[data-google-all]'), write = root.querySelector('[data-google-write]');
          if (data.url) { all.href = data.url; all.hidden = false; all.parentNode.hidden = false; }
          if (data.writeUrl) { write.href = data.writeUrl; write.hidden = false; write.parentNode.hidden = false; }
        })
        .catch(function () {});
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuno-product-reviews"] && !Shopify.designMode) return;
  try {
    

(function() {
  'use strict';

  function initReviewsSection() {
    var section = document.querySelector('[data-reviews-section]');
    if (!section) return;

    var btnMore     = section.querySelector('[data-reviews-open]');
    var modalOverlay= section.querySelector('[data-reviews-modal-overlay]');
    var modalClose  = section.querySelector('[data-reviews-modal-close]');
    var modalBody   = section.querySelector('[data-reviews-modal-body]');
    var jdgmBox     = section.querySelector('[data-reviews-box]');

    var avgEl   = section.querySelector('[data-reviews-avg]');
    var starsEl = section.querySelector('[data-reviews-stars]');
    var countEl = section.querySelector('[data-reviews-count]');
    var fills   = section.querySelectorAll('[data-bar-fill]');
    var productId = section.getAttribute('data-product-id');

    function getWidgetData() {
      return (window.nunoReviewData && window.nunoReviewData[productId]) ||
             (window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget && window.jdgm.data.reviewWidget[productId]);
    }

    function renderProgressiveStars(rating) {
      if (!starsEl) return;
      var score = Math.max(0, Math.min(5, parseFloat(rating) || 0));
      var starSvgs = starsEl.querySelectorAll('.nuno-reviews__star-svg');
      
      starSvgs.forEach(function(star, idx) {
        var starNumber = idx + 1;
        var fillPct = 0;
        
        if (score >= starNumber) {
          fillPct = 100;
        } else if (score > starNumber - 1) {
          fillPct = Math.round((score - (starNumber - 1)) * 100);
        } else {
          fillPct = 0;
        }
        
        var filledStop = star.querySelector('.star-stop-filled');
        var emptyStop = star.querySelector('.star-stop-empty');
        if (filledStop) filledStop.setAttribute('offset', fillPct + '%');
        if (emptyStop) emptyStop.setAttribute('offset', fillPct + '%');
      });
    }

    function syncStats() {
      var data = getWidgetData();
      var avg, count;

      if (data) {
        avg   = parseFloat(data.average_rating || data.avg_rating || data.rating || data.score || 0);
        count = parseInt(data.number_of_reviews || data.review_count || data.count || 0, 10);
      }

      if (!avg || avg === 0) {
        var scoreEl = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__summary-score, #judgeme_product_reviews [class*="summary-score"], .jdgm-prev-badge__rating, .jdgm-preview-badge .jdgm-star');
        var countEl2 = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__summary-reviews-count, #judgeme_product_reviews [class*="reviews-count"], .jdgm-prev-badge__count, .jdgm-prev-badge__text');
        if (scoreEl) avg = parseFloat(scoreEl.getAttribute('data-score') || scoreEl.getAttribute('data-average-rating') || scoreEl.textContent);
        if (countEl2) count = parseInt(countEl2.textContent.replace(/[^0-9]/g, ''), 10);
      }

      if (!isNaN(avg) && avg > 0) {
        if (avgEl) avgEl.textContent = avg.toFixed(2);

        renderProgressiveStars(avg);

        if (countEl && !isNaN(count) && count > 0) {
          countEl.innerHTML = 'Na podstawie ' + count + ' opinii<br>ze sklepu NUNO';
        }
        return true;
      }
      return false;
    }

    function syncBars() {
      var data = getWidgetData();
      if (!data || !Array.isArray(data.histogram)) return false;

      var dist = { "5": 0, "4": 0, "3": 0, "2": 0, "1": 0 };
      var totalCount = 0;

      data.histogram.forEach(function(item) {
        if (item && item.rating && dist.hasOwnProperty(String(item.rating))) {
          var f = parseInt(item.frequency, 10) || 0;
          dist[String(item.rating)] = f;
          totalCount += f;
        }
      });

      if (totalCount === 0) return false;

      [5, 4, 3, 2, 1].forEach(function(star, idx) {
        var fill = fills[idx];
        if (!fill) return;

        var countForStar = dist[String(star)] || 0;
        var pct = Math.round((countForStar / totalCount) * 100);

        if (countForStar > 0 && pct === 0) pct = 1;

        fill.setAttribute('data-bar-fill', pct);
        fill.style.width = pct + '%';
        var row = fill.closest('.nuno-reviews__bar-row');
        if (row) {
          var pctSpan = row.querySelector('.nuno-reviews__bar-pct');
          if (pctSpan) pctSpan.textContent = pct + '%';
        }
      });
      return true;
    }

    function updateAll() {
      var s = syncStats();
      var b = syncBars();
      return s && b;
    }

    // Natychmiastowe wykonanie (0ms - dane są w window.nunoReviewData)
    var isReady = updateAll();

    if (!isReady) {
      var widgetDiv = document.getElementById('judgeme_product_reviews');
      var mo = null;

      if (widgetDiv) {
        mo = new MutationObserver(function() {
          if (updateAll() && mo) {
            mo.disconnect();
          }
        });
        mo.observe(widgetDiv, { childList: true, subtree: true });
      }

      ['jdgm:widget:loaded', 'jdgm:all:loaded', 'jdgm:reviews:loaded'].forEach(function(evtName) {
        document.addEventListener(evtName, function() {
          if (updateAll() && mo) mo.disconnect();
        }, { once: true });
      });

      var attempts = 0;
      var poll = setInterval(function() {
        attempts++;
        if (updateAll() || attempts > 15) {
          clearInterval(poll);
          if (mo) mo.disconnect();
        }
      }, 200);
    }

    /* DESKTOP EXPAND / COLLAPSE REVIEWS */
    var btnMoreDesktop = section.querySelector('.nuno-reviews__btn-more--desktop');
    if (btnMoreDesktop && jdgmBox) {
      btnMoreDesktop.addEventListener('click', function(e) {
        e.preventDefault();
        var isExp = jdgmBox.classList.toggle('is-expanded');
        btnMoreDesktop.setAttribute('aria-expanded', isExp ? 'true' : 'false');
        btnMoreDesktop.innerHTML = isExp 
          ? 'Zwiń opinie <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="transform: rotate(180deg);"><path d="M5 12h14M12 5l7 7-7 7"/></svg>'
          : 'Przeglądaj opinie <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
      });
    }

    /* MOBILE FULLSCREEN POPUP MODAL */
    var pdWidget = section.querySelector('#judgeme_product_reviews');
    var btnMoreMobile = section.querySelector('.nuno-reviews__btn-more--mobile');

    function openReviewsModal() {
      if (!modalOverlay || !modalBody || !pdWidget) return;
      modalBody.appendChild(pdWidget);
      modalOverlay.classList.add('is-active');
      modalOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeReviewsModal() {
      if (!modalOverlay) return;
      if (jdgmBox && pdWidget) {
        jdgmBox.appendChild(pdWidget);
      }
      modalOverlay.classList.remove('is-active');
      modalOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (btnMoreMobile) {
      btnMoreMobile.addEventListener('click', function(e) {
        e.preventDefault();
        openReviewsModal();
      });
    }

    if (modalClose) {
      modalClose.addEventListener('click', closeReviewsModal);
    }

    if (modalOverlay) {
      modalOverlay.addEventListener('click', function(e) {
        if (e.target === modalOverlay) closeReviewsModal();
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modalOverlay && modalOverlay.classList.contains('is-active')) {
        closeReviewsModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsSection);
  } else {
    initReviewsSection();
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-brewing-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBrewGuide(root) {
      if (root.dataset.brewReady) return;
      root.dataset.brewReady = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-brew-panel]'));

      function select(key, focus) {
        tabs.forEach(function (tab) {
          var active = tab.getAttribute('data-brew-key') === key;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
          if (active) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-brew-panel') !== key;
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          select(tab.getAttribute('data-brew-key'), false);
        });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            event.preventDefault();
            select(next.getAttribute('data-brew-key'), true);
          }
        });
      });

      var initial = root.getAttribute('data-brew-default') || (tabs[0] && tabs[0].getAttribute('data-brew-key'));
      if (initial) select(initial, false);
    }

    function initAll() {
      document.querySelectorAll('[data-brew-guide]').forEach(initBrewGuide);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
